{
	"title": "Lag erklæring",
	"backLinkToMaterialDetailsTitle": "Tilbake til Materialdetaljer",
	"backLinkToMaterialDetailsWithDescriptionTitle": "Tilbake til {{materialDescription}}",
	"backLinkToManageDeclarationsTitle": "Tilbake til Administrer erklæringer",
	"steps": {
		"firstStep": {
			"title": "Trinn 1",
			"label": "1"
		},
		"secondStep": {
			"title": "Trinn 2",
			"label": "2"
		},
		"thirdStep": {
			"title": "Trinn 3",
			"label": "3"
		}
	}
}
